import { global } from ":shared/app";
import type { UpdatePasswordProps, UpdateProfileImageProps, UpdateProfileProps } from "../_model";

export const endpoint = "auth/password-update/";

export type PUT = {
  props: {
    password: string;
  };
};
export async function put(data: UpdatePasswordProps) {
  return global.api
    .putAuth(endpoint, data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(async (res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
